import { GridColDef, GridColumnGroupingModel, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatTo0Decimal, formatToNumber, isEmpty, isEmptyArray } from '../../common/util.services';
import { getPrdSale, getPrdSaleOverall} from '../amazon.services';
import { Button, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import '../amazon.scss';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PieChartIcon from '@mui/icons-material/PieChart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import AmazonProductSale from './product-sale.component';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import ProductSalePieChart from './product-pie-chart.component';
import { AssessmentOutlined } from '@mui/icons-material';
import ProductSaleBarChart from './product-bar-chart.component';
import ProductTopSku from './product-top.component';

const AmazonAllProductSale = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const [searchData, setSearchData] = useState<any>({period: 'Monthly', type: 'Total Unit', 
                                                     startDate: dayjs().subtract(DAYS_QTR, 'day'), endDate: dayjs()});
  const [openPrd, setOpenPrd] = useState(false);
  const [productData, setProductData] = useState([]);
  const [prdSaleOverall, setPrdSaleOverall] = useState<any>([])
  const [prdSaleData, setPrdSaleData] = useState([{period: 'Loading...'}])
  const [loading, setLoading] = useState(true);
  const [openPieChart, setOpenPieChart] = useState(false);
  const [openBarChart, setOpenBarChart] = useState(false);
  const [openTopSku, setOpenTopSku] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'period', headerName: 'Period', filterable: false, sortable: false, editable: false, width: 110,
      cellClassName: (params) => { return "Tacos2" }
    },
    { field: 'countTotal', headerName: 'Count', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countTotal) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'saleTotal', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleTotal) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'countSalsaNapkin', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countSalsaNapkin) },
    },
    { field: 'saleSalsaNapkin', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleSalsaNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctSalsaNapkin', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctSalsaNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countLaundryBag', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countLaundryBag) },
    },
    { field: 'saleLaundryBag', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleLaundryBag) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctLaundryBag', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctLaundryBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countShoeBag', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countShoeBag) },
    },
    { field: 'saleShoeBag', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleShoeBag) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctShoeBag', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctShoeBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsPlacemat', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countBsPlacemat) },
    },
    { field: 'saleBsPlacemat', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsPlacemat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsPlacemat', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctBsPlacemat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsRunner', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countBsRunner) },
    },
    { field: 'saleBsRunner', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsRunner) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsRunner', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctBsRunner) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCanvasTableCloth', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCanvasTableCloth) },
    },
    { field: 'saleCanvasTableCloth', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCanvasTableCloth) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCanvasTableCloth', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCanvasTableCloth) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countWineBottleCover', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countWineBottleCover) },
    },
    { field: 'saleWineBottleCover', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleWineBottleCover) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctWineBottleCover', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctWineBottleCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsCushionCover', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countBsCushionCover) },
    },
    { field: 'saleBsCushionCover', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsCushionCover) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsCushionCover', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctBsCushionCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countFoutaTowel', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countFoutaTowel) },
    },
    { field: 'saleFoutaTowel', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleFoutaTowel) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctFoutaTowel', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctFoutaTowel) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countDobbyNapkin', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countDobbyNapkin) },
    },
    { field: 'saleDobbyNapkin', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleDobbyNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctDobbyNapkin', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctDobbyNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCanvasCurtain', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCanvasCurtain) },
    },
    { field: 'saleCanvasCurtain', headerName: 'Sale', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCanvasCurtain) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCanvasCurtain', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCanvasCurtain) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countSlubDuck', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countSlubDuck) },
    },
    { field: 'saleSlubDuck', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleSlubDuck) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctSlubDuck', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctSlubDuck) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCottonYogaMat', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCottonYogaMat) },
    },
    { field: 'saleCottonYogaMat', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCottonYogaMat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCottonYogaMat', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCottonYogaMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countStrawYogaMat', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countStrawYogaMat) },
    },
    { field: 'saleStrawYogaMat', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleStrawYogaMat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctStrawYogaMat', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctStrawYogaMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countUtilityBag', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countUtilityBag) },
    },
    { field: 'saleUtilityBag', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleUtilityBag) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctUtilityBag', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctUtilityBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCheckRunner', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCheckRunner) },
    },
    { field: 'saleCheckRunner', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCheckRunner) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCheckRunner', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCheckRunner) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countFlaxNapkin', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countFlaxNapkin) },
    },
    { field: 'saleFlaxNapkin', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleFlaxNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctFlaxNapkin', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctFlaxNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCushionCover', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCushionCover) },
    },
    { field: 'saleCushionCover', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCushionCover) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCushionCover', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCushionCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCheckNapkin', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countCheckNapkin) },
    },
    { field: 'saleCheckNapkin', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCheckNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCheckNapkin', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctCheckNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countPlainNapkin', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countPlainNapkin) },
    },
    { field: 'salePlainNapkin', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.salePlainNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctPlainNapkin', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctPlainNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countKitchenTowel', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countKitchenTowel) },
    },
    { field: 'saleKitchenTowel', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleKitchenTowel) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctKitchenTowel', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctKitchenTowel) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countStrawMat', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countStrawMat) },
    },
    { field: 'saleStrawMat', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleStrawMat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctStrawMat', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctStrawMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBambooMat', headerName: 'Count', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdSale(params.row.countBambooMat) },
    },
    { field: 'saleBambooMat', headerName: 'Sale', width: 75, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBambooMat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBambooMat', headerName: '% Sale', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdSale(params.row.pctBambooMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    }
  ];

  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columnGroupingModel: GridColumnGroupingModel = [
    { groupId: 'Chart', headerAlign: 'left', headerClassName: 'Tacos2',
      children: [{ field: 'period' }],
      renderHeaderGroup: (params) => (<Stack direction="row" spacing={0} alignItems="right">
                                      <Tooltip title={'Order Distribution'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openSalePieChart}>
                                        <PieChartIcon fontSize="small" color='primary'/></IconButton></Tooltip>
                                      <Tooltip title={'Order Trend'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openSaleBarChart}>
                                        <AssessmentOutlined fontSize="small" color='primary'/></IconButton></Tooltip>
                                      <Tooltip title={'Top Selling SKU'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openTopSkuPopup}>
                                        <ListAltIcon fontSize="small" color='primary'/></IconButton></Tooltip>
                                      </Stack>)},
    { groupId: 'Total', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countTotal' }, { field: 'saleTotal' }]},
    { groupId: 'Salsa Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countSalsaNapkin' }, { field: 'saleSalsaNapkin' }, { field: 'pctSalsaNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Laundry Bag', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countLaundryBag' }, { field: 'saleLaundryBag' }, { field: 'pctLaundryBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Shoe Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countShoeBag' }, { field: 'saleShoeBag' }, { field: 'pctShoeBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Slub Duck', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countSlubDuck' }, { field: 'saleSlubDuck' }, { field: 'pctSlubDuck' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Cotton Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCottonYogaMat' }, { field: 'saleCottonYogaMat' }, { field: 'pctCottonYogaMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Straw Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countStrawYogaMat' }, { field: 'saleStrawYogaMat' }, { field: 'pctStrawYogaMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Utility Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countUtilityBag' }, { field: 'saleUtilityBag' }, { field: 'pctUtilityBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Check Runner', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCheckRunner' }, { field: 'saleCheckRunner' }, { field: 'pctCheckRunner' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Flax Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countFlaxNapkin' }, { field: 'saleFlaxNapkin' }, { field: 'pctFlaxNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Placemat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countBsPlacemat' }, { field: 'saleBsPlacemat' }, { field: 'pctBsPlacemat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Runner', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countBsRunner' }, { field: 'saleBsRunner' }, { field: 'pctBsRunner' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Canvas Table Cloth', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCanvasTableCloth' }, { field: 'saleCanvasTableCloth' }, { field: 'pctCanvasTableCloth' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Wine Bottle Cover', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countWineBottleCover' }, { field: 'saleWineBottleCover' }, { field: 'pctWineBottleCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countBsCushionCover' }, { field: 'saleBsCushionCover' }, { field: 'pctBsCushionCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Fouta Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countFoutaTowel' }, { field: 'saleFoutaTowel' }, { field: 'pctFoutaTowel' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Dobby Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countDobbyNapkin' }, { field: 'saleDobbyNapkin' }, { field: 'pctDobbyNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Canvas Curtain', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCanvasCurtain' }, { field: 'saleCanvasCurtain' }, { field: 'pctCanvasCurtain' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCushionCover' }, { field: 'saleCushionCover' }, { field: 'pctCushionCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Check Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCheckNapkin' }, { field: 'saleCheckNapkin' }, { field: 'pctCheckNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Plain Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countPlainNapkin' }, { field: 'salePlainNapkin' }, { field: 'pctPlainNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Kitchen Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countKitchenTowel' }, { field: 'saleKitchenTowel' }, { field: 'pctKitchenTowel' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Straw Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countStrawMat' }, { field: 'saleStrawMat' }, { field: 'pctStrawMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Bamboo Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countBambooMat' }, { field: 'saleBambooMat' }, { field: 'pctBambooMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdSale(params.headerName)}}>{params.headerName}</Button>)}
  ];

  function getClassNamePrdSale(value: any) {
    return isEmpty(value) || 0 === value ? 'PrdSaleNegative' : 'PrdSalePositive';
  }

  useEffect(() => {
    getPrdSaleData();
  }, [page, pageSize, searchData]);

  function getPrdSaleData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getPrdSale(searchData, page, pageSize, appContext,
        (response: any) => {
          setPrdSaleData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    setLoading(true);
    getPrdSaleOverall(searchData, appContext,
      (response: any) => {
        setPrdSaleOverall(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }, [searchData]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const openPrdSale = (value: any) => {
    let data: any = [value, searchData.startDate, searchData.endDate];
    setProductData(data);
    setOpenPrd(true);
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? '0' : formatTo0Decimal(Math.round(value * 1));
  }

  const getValuePctDecimal = (value: any) => {
    return isEmpty(value) ? '0%' : formatTo0Decimal(Math.round(value * 100)) + '%';
  }

  const getPrdCount = (value: any) => {
    return isEmpty(prdSaleOverall[value]) ? '0' : formatToNumber(prdSaleOverall[value]);
  }

  const search = (data: any) => {
    setPage(0);
    setSearchData(data);
  }
  
  const closePrdPopup = (e: any) => {
    setOpenPrd(false);
  }

  const closePieChart = (e: any) => {
    setOpenPieChart(false);
  }

  const openSalePieChart = (e: any) => {
    setOpenPieChart(true);
  }

  const openSaleBarChart = (e: any) => {
    setOpenBarChart(true);
  }

  const openTopSkuPopup = (e: any) => {
    setOpenTopSku(true);
  }

  const closeBarChart = (e: any) => {
    setOpenBarChart(false);
  }

  const closeTopSku = (e: any) => {
    setOpenTopSku(false);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={3}>
          <IDateField name='startDate' label='Start Date' timeZone="America/Los_Angeles"/>
        </Grid>
        <Grid xs={3}>
          <IDateField name='endDate' label='End Date' timeZone="America/Los_Angeles"/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='period' label='Period' itemList={['Daily', 'Monthly']} required={true} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='type' label='Type' itemList={['ASIN Unit', 'Total Unit']} required={true} />
        </Grid>
      </Grid>
    </SearchPanel>
  }
  
  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2}>
            <IReadOnlyField label='Days' value={prdSaleOverall.Days}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Total' value={getPrdCount('Total')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Salsa Napkin' value={getPrdCount('Salsa Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Laundry Bag' value={getPrdCount('Laundry Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Shoe Bag' value={getPrdCount('Shoe Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Slub Duck' value={getPrdCount('Slub Duck')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Curtain' value={getPrdCount('Canvas Curtain')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cotton Yoga Mat' value={getPrdCount('Cotton Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Straw Yoga Mat' value={getPrdCount('Straw Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Utility Bag' value={getPrdCount('Utility Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Fouta Towel' value={getPrdCount('Fouta Towel')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Runner' value={getPrdCount('BS Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Placemat' value={getPrdCount('BS Placemat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Cushion Cover' value={getPrdCount('BS Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Wine Bottle Cover' value={getPrdCount('Wine Bottle Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Dobby Napkin' value={getPrdCount('Dobby Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Table Cloth' value={getPrdCount('Canvas Table Cloth')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Runner' value={getPrdCount('Check Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Flax Napkin' value={getPrdCount('Flax Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cushion Cover' value={getPrdCount('Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Napkin' value={getPrdCount('Check Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Plain Napkin' value={getPrdCount('Plain Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Kitchen Towel' value={getPrdCount('Kitchen Towel')}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={prdSaleData} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          getRowId={(row: any) => row.period} columnGroupingModel={columnGroupingModel}
          showAction={false} showApproveAction={false} showDeleteAction={false} showEditAction={false} />
      <IDialogComponent onClose={closePrdPopup} open={openPrd} title={'Product Order'}
        dialogBody={<AmazonProductSale productData={productData}/>} />
      <IDialogComponent onClose={closePieChart} open={openPieChart} title='Order Distribution' 
        dialogBody={<ProductSalePieChart />} />
      <IDialogComponent onClose={closeBarChart} open={openBarChart} title='Order Trend' 
        dialogBody={<ProductSaleBarChart />} />
      <IDialogComponent onClose={closeTopSku} open={openTopSku} title='Top Selling SKU' 
        dialogBody={<ProductTopSku />} />
    </>
  }

  return <TitlePanel title='Product Order' panelBody={getMainPanel()} />
}

export default AmazonAllProductSale;